import React, { useState } from 'react';
import './FAQ.css';

interface FAQItem {
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    question: "Care sunt modalitățile de livrare a cerealelor?",
    answer: "Livrăm cerealele prin intermediul flotei noastre de camioane, asigurând transport rapid și sigur. Livrările se fac atât pe drumurile naționale, cât și pe trasee regionale, în funcție de locația ta.",
  },
  // {
  //   question: "Ce tipuri de cereale oferiți pentru vânzare?",
  //   answer: "Comercializăm grâu și porumb de cea mai bună calitate, atent selecționate și livrate direct de la depozit. Produsele noastre sunt ideale atât pentru utilizarea în agricultură, cât și pentru alte industrii.",
  // },
  {
    question: "Cum pot comanda cereale sau solicita un transport?",
    answer: "Pentru a comanda cereale sau a solicita un transport, poți contacta echipa noastră prin telefon sau e-mail. De asemenea, poți completa formularul de contact de pe site, iar un reprezentant va reveni cu o ofertă.",
  },
];

const FAQ: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="faq">
      {faqData.map((item, index) => (
        <div key={index} className="faq-item">
          <div
            className={`faq-question ${activeIndex === index ? 'active' : ''}`}
            onClick={() => toggleFAQ(index)}
          >
            <span>{item.question}</span>
            <span className="faq-icon">{activeIndex === index ? '-' : '+'}</span>
          </div>
          <div
            className={`faq-answer ${activeIndex === index ? 'show' : ''}`}
          >
            {item.answer}
          </div>
          <div className="faq-divider" />
        </div>
      ))}
    </div>
  );
};

export default FAQ;
